/* Building blocks shared across screens. */

.screen {
  position: absolute;
  inset: 0;
}
.fadeUp {
  animation: evx-fadeUp 0.5s ease both;
}

.kicker {
  font-size: 12px;
  letter-spacing: 0.2em;
  color: var(--color-accent-700);
  font-weight: 700;
}
.label {
  font-size: 11px;
  font-weight: 700;
  color: var(--color-accent-700);
}
.fieldLabel {
  font-size: 11px;
  color: var(--color-neutral-600);
  font-weight: 700;
}
.reveal {
  animation: evx-reveal 0.8s ease both;
}

/* Page header for the selection screens: kicker + title on the left, an action on the right. */
.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.title {
  margin: 8px 0 0;
  font-weight: 800;
  color: var(--color-text);
}

.card {
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
}

/* Floating confirmation bar along the bottom of the selection screens. */
.actionBar {
  position: absolute;
  left: 72px;
  right: 72px;
  bottom: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 28px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  animation: evx-fadeUp 0.3s ease both;
}
.actionTitle {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 22px;
  color: var(--color-text);
}

/*
 * Reset for <button>s styled as tiles or cards. Zero specificity via :where(), so the component's
 * own border/padding always win regardless of stylesheet order.
 */
:where(.tile) {
  appearance: none;
  border: none;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: inherit;
  cursor: pointer;
}
